import isEmpty from "lodash.isempty";

function normalizeFilters(filters) {
  if (!isEmpty(filters)) {
    return filters.reduce((prev, curr) => {
      return { ...prev, [curr.filterName]: curr.filterValue };
    }, {});
  }

  return {};
}

export default normalizeFilters;
